<template>
    <div
        class="dorm-component flex flex-row justify-center"
        :class="{ 'has-popup': activeRoom }"
        @click="closePopup()"
        style="height: 170vh"
    >
        <div
            class="relative lg:block lg:w-2/6 xl:w-2/6 2xl:w-2/5 w-full"
            :class="{ hidden: view !== 'floor' }"
        >
            <FloorComponent
                v-for="[f, rooms] in Object.entries(floors).reverse()"
                :key="f"
                :id="f"
                :rooms="rooms"
                :style="{
                    transition: 'none',
                    transform: `${isMobile ? '' : 'translateX(-50%)'} scale(${Math.pow(
                        1.5,
                        -(tweenedFloor - f)
                    )}, ${Math.pow(1.1, -(tweenedFloor - f))})`,
                    opacity: Math.exp(-Math.pow(tweenedFloor - f, 2) * Math.sqrt(10)),
                    visibility:
                        Math.exp(-Math.pow(tweenedFloor - f, 2) * Math.sqrt(10)) > 0.1
                            ? 'visible'
                            : 'hidden',
                    display:
                        Math.exp(-Math.pow(tweenedFloor - f, 2) * Math.sqrt(10)) > 0.1
                            ? 'block'
                            : 'none',
                }"
                classNames="active lg:absolute lg:top-0 lg:left-1/2 mobile:items-center pb-10 lg:pb-16"
                :size="13"
                layout="vertical"
            />
        </div>
        <div
            class="lg:block lg:w-4/6 xl:w-4/6 2xl:w-3/5 w-full my-6"
            :class="{ hidden: view !== 'dorm' }"
        >
            <FloorComponent
                v-for="[f, rooms] in Object.entries(floors).reverse()"
                :key="f"
                :id="f"
                :title="f === '0' ? 'Földszint' : `${f}. emelet`"
                :rooms="rooms"
                :size="setSize"
                :classNames="`cursor-pointer ${f === `${floor}` ? 'active' : ''}`"
                layout="horizontal"
            />
        </div>
        <popup-component />
        <notification-component />
    </div>
</template>

<script>
import gsap, { Power0 } from 'gsap';
import { mapActions, mapGetters } from 'vuex';
import floors from '../../store/constants/floors';
import FloorComponent from './FloorComponent';
import PopupComponent from './PopupComponent';
import NotificationComponent from './NotificationComponent';

export default {
    name: 'DormComponent',
    components: { NotificationComponent, PopupComponent, FloorComponent },
    computed: {
        floors() {
            return floors;
        },
        setSize() {
            // TODO: remove this & i know its a shit
            if (window.matchMedia('(min-width: 1536px)').matches) {
                // this.isMobile = false;
                return 8;
            } else if (window.matchMedia('(min-width: 1280px)').matches) {
                // this.isMobile = false;
                return 8;
            } else if (window.matchMedia('(min-width: 1024px)').matches) {
                // this.isMobile = false;
                return 6;
            } else if (window.matchMedia('(min-width: 768px)').matches) {
                // this.isMobile = true;
                return 7;
            } else if (window.matchMedia('(min-width: 640px)').matches) {
                // this.isMobile = true;
                return 6;
            }
            // this.isMobile = true;
            return 3;
        },
        ...mapGetters('Popup', ['activeRoom']),
        ...mapGetters('Room', ['floor', 'view']),
        ...mapGetters('User', ['isAuthenticated']),
    },
    data() {
        return {
            tweenedFloor: 1,
            isMobile: true, // TEMP false,
        };
    },
    methods: {
        ...mapActions('Room', ['getRoomsAsync']),
        ...mapActions('Popup', ['selectRoom']),
        closePopup() {
            this.selectRoom(null);
        },
    },
    watch: {
        floor(newFloor, oldFloor) {
            const duration = this.isMobile
                ? 0
                : Math.log10(Math.abs((newFloor - oldFloor) * 5) / 3);
            gsap.to(this, { duration, ease: Power0.easeNone, tweenedFloor: Number(newFloor) });
        },
        isAuthenticated(newState, oldState) {
            if (newState) this.getRoomsAsync();
        },
    },
};
</script>

<style scoped>
.dorm-component.has-popup {
    padding-bottom: 240px;
}
</style>
